export default {"src":"/_next/static/media/pc_consultunt_img_04.01e521eb.svg","height":140,"width":480};